// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ValorServicosFranquias_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET
 * /config/valor_servicos_franquias/lista/{franquia_id?}/{categoria_id?}.
 *
 * dados is the per-franchise service-pricing matrix built by
 * Valor_servicos_franquias_model::lista(). See ValorServicosFranquias_ListaRow
 * for the per-row shape.
 */
import type { ValorServicosFranquias_ListaRow } from './ValorServicosFranquias_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ValorServicosFranquias_ListaResponseDados = ValorServicosFranquias_ListaRow[];

export type ValorServicosFranquias_ListaResponse = ApiResponse<ValorServicosFranquias_ListaResponseDados>;

registerResponseContract('ValorServicosFranquias_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      franquia_id:             { type: 'number',  required: true },
      franquia:                { type: 'string',  required: false },
      servico_id:              { type: 'string',  required: false },
      servicoscategoria_nome:  { type: 'string',  required: false },
      servicoscategoria_id:    { type: 'string',  required: false },
      servico_nome:            { type: 'string',  required: false },
      servico_valor_padrao:    { type: 'string',  required: false },
      valorservicofranquia_id: { type: 'string',  required: false },
      valor_padrao_franquia:   { type: 'string',  required: false },
      valor_minimo_franquia:   { type: 'string',  required: false },
    },
  },
})
